package ru.dinarastepina.fabvocab.web.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px
import ru.dinarastepina.fabvocab.domain.model.WordEntry
import ru.dinarastepina.fabvocab.web.theme.*

@Composable
fun WordCard(
    word: WordEntry,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val theme = posThemeFor(word.partOfSpeech)

    Box(
        modifier = modifier
            .fillMaxWidth()
            .backgroundColor(Color("#FFFFFF"))
            .border(2.px, LineStyle.Solid, Slate100)
            .borderRadius(20.px)
            .padding(16.px)
            .onClick { onClick() }
            .cursor(com.varabyte.kobweb.compose.css.Cursor.Pointer),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = com.varabyte.kobweb.compose.foundation.layout.Arrangement.SpaceBetween,
        ) {
            Column(modifier = Modifier) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    SpanText(
                        word.word,
                        modifier = Modifier
                            .fontSize(18.px)
                            .fontWeight(FontWeight.Black)
                            .color(theme.text),
                    )
                    word.partOfSpeech?.let { pos ->
                        Box(
                            modifier = Modifier
                                .margin(left = 6.px)
                                .backgroundColor(theme.background)
                                .borderRadius(6.px)
                                .padding(leftRight = 6.px, topBottom = 2.px),
                        ) {
                            SpanText(
                                pos.lowercase(),
                                modifier = Modifier
                                    .fontSize(10.px)
                                    .fontWeight(FontWeight.Bold)
                                    .color(theme.text)
                                    .letterSpacing(0.5.px),
                            )
                        }
                    }
                }
                word.phonetic?.let {
                    SpanText(
                        it,
                        modifier = Modifier
                            .fontSize(12.px)
                            .fontWeight(FontWeight.SemiBold)
                            .color(Slate400)
                            .margin(top = 4.px),
                    )
                }
            }

            Box(
                modifier = Modifier
                    .size(36.px)
                    .backgroundColor(Slate50)
                    .borderRadius(12.px),
                contentAlignment = Alignment.Center,
            ) {
                SpanText(
                    "›",
                    modifier = Modifier
                        .fontSize(18.px)
                        .fontWeight(FontWeight.Bold)
                        .color(Slate400),
                )
            }
        }
    }
}
